export class Filter {
	constructor(
		public ids?: any,
		public sort?: any,
		public category?: any,
		public filter?: any,
		public filterItems?: any,
		public hidden?: any,
		public page?: any,
		public min?: any,
		public max?: any
	) {}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/models/filter.constructor.ts